import helper from './helper'
import throttle from 'lodash.throttle'

const animateApplyButton = {
    $trigger: $('.js-section-article-content'),
    header: $('.js-section-article-content'),
    button: $('.js-sticky-button-container'),
    isNotDesktop: $(window).width() < 1025,

    init: function () {
        let _this = this

        if (_this.$trigger.length) {
            //Show or hide button on first load or after refresh
            if (_this.isNotDesktop) {
                if (
                    helper.isElementInViewport(
                        $(_this.header),
                        'partialPastView'
                    )
                ) {
                    $(_this.button).css('opacity', '1')
                }
            }
            //Show or hide button based on scroll and resize after initial load
            $(window).on(
                'scroll resize orientationchange',
                throttle(() => {
                    if (_this.isNotDesktop) {
                        if (
                            helper.isElementInViewport(
                                $(_this.header),
                                'partialPastView'
                            )
                        ) {
                            $(_this.button).css('opacity', '1')
                        } else {
                            $(_this.button).css('opacity', '0')
                        }
                    }
                }, 120)
            )
        }
    },
}

animateApplyButton.init()
